import { instance } from '../../util/http'
import apis from '../../config/apis'

const wxLoginRedirect = (data) => {
    return instance.post(apis.WxUserInfo.Get,data,{headers: {'Content-Type': 'application/json'}} );
}
//win新增 检查散户是否跳转绑定页
const LoginUserIsBind = (openId) => {
    return instance.get(apis.WxUserInfo.LoginCheckBind + "?openId=" + openId );
}
// lhy测试登录接口
const wxLoginTest = (OpenId,IsShared,SharedType,GoodsId,RaffleId) => {
    if (SharedType == 1) {
        return instance.get(apis.WxUserInfo.TestGet + "?OpenId=" + OpenId + "&IsShared=" + IsShared+ "&SharedType=" + SharedType + "&GoodsId=" + GoodsId);
    }else if(SharedType == 2){
        return instance.get(apis.WxUserInfo.TestGet + "?OpenId=" + OpenId + "&IsShared=" + IsShared+ "&SharedType=" + SharedType + "&GoodsId=" + GoodsId + "&RaffleId=" + RaffleId);
    }else{
        return instance.get(apis.WxUserInfo.TestGet + "?OpenId=" + OpenId );
    }
}
// lhy 后端积分扫码记录接口
const scanRecord = (params) =>{
   return instance.post(apis.WxUserInfo.ScanRecord,params)
};
const getNewStatus = (openId ) => {
    return instance.get(apis.WxUserInfo.GetStatus + "?openId=" + openId)
};
const isDebugger = () => {
    return instance.post(apis.WxUserInfo.Debugger)
};
// 登录获取活动详情
const packageDetail = () => {
    return instance.get(apis.WxUserInfo.PackageDetail)
};
export default {
    wxLoginRedirect,
    LoginUserIsBind,
    wxLoginTest,
    getNewStatus,
    isDebugger,
    scanRecord,
    packageDetail
}